export const AUTH_TOKEN = "AUTH_TOKEN";
export const USER_KEY = "USER";
// export const API_BASE_URL = 'https://pmpmedia-api.herokuapp.com/api/v1';
export const API_BASE_URL = 'https://pompie-media-node-api.vercel.app/api/v1';
// https://pompie-media-node-api.vercel.app/
// export const API_BASE_URL = 'http://localhost:3001/api/v1';